module.exports = __webpack_public_path__ + "static/media/3ofakind.000f1db8.png";